export default "__VITE_ASSET__CPZf9seO__"